// Hedef ilerleme çubuğu (TODO-KPI-01) — 0..100, ton: ulaşıldı/yolda/geride/nötr.
import type { KpiTargetProgress } from "@mahir/shared";
import {
  progressPct,
  targetTone,
  targetToneColor,
  targetToneLabel,
} from "../../../lib/kpi-targets-ui";

export function TargetProgressBar({ progress }: { progress: KpiTargetProgress }): JSX.Element {
  const tone = targetTone(progress);
  const pct = progressPct(progress);
  const color = targetToneColor(tone);
  return (
    <div className="flex items-center gap-2" style={{ minWidth: 140 }}>
      <div
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label={`İlerleme %${pct} · ${targetToneLabel(tone)}`}
        style={{
          flex: 1,
          height: 8,
          borderRadius: 999,
          background: "var(--color-bg)",
          border: "1px solid var(--color-border)",
          overflow: "hidden",
        }}
      >
        <div
          style={{ width: `${pct}%`, height: "100%", background: color, transition: "width .2s" }}
        />
      </div>
      <span
        style={{
          fontSize: "0.72rem",
          fontWeight: 700,
          color,
          minWidth: 64,
          whiteSpace: "nowrap",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {progress.progress === null ? "—" : `%${pct} · ${targetToneLabel(tone)}`}
      </span>
    </div>
  );
}
